// Real client reviews (shown on the homepage and course pages).
export const TESTIMONIALS = [
    {
      quote: "My experience with Compliance Management Systems and Marshalee Valentine has been excellent; a well deserved 5 star rating. They don't just teach about quality; they embody quality and set the standard for excellence. Do yourself a favor and book a consultation or training course.",
      author: "Tashique Gibson",
      role: "Quality Officer",
      company: "IGL Limited",
      rating: 5
    },
    {
      quote: "Marshalee was quite engaging. She was knowledgeable of the topics being delivered in food safety and provided opportunities for the team to seek clarification.",
      author: "Kemon Deer",
      role: "",
      company: "T. Geddes Grant Jamaica",
      rating: 5
    },
    {
      quote: "Valuable training materials were provided for our Internal Audit Training and the trainings are engaging and value added.",
      author: "Kirkdale Hutchinson",
      role: "Distribution Centre Optimisation Manager",
      company: "GK Distribution Centre",
      rating: 5
    }
];
